import { render } from "./BirdSelect_Collapsable.vue?vue&type=template&id=46e47fd4&scoped=true"
import script from "./BirdSelect_Collapsable.vue?vue&type=script&lang=js"
export * from "./BirdSelect_Collapsable.vue?vue&type=script&lang=js"

import "./BirdSelect_Collapsable.vue?vue&type=style&index=0&id=46e47fd4&scoped=true&lang=css"

import exportComponent from "/Users/lasse/Documents/DOFprojects/Danmarksfugle2.0-frontend/code-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46e47fd4"]])

export default __exports__